import { bool, string } from 'prop-types'

export const blogEntryType = {
  imageSrc: string.isRequired,
  imageAlt: string.isRequired,
  imageLazyLoad: bool,
  title: string.isRequired,
  date: string.isRequired,
  url: string.isRequired,
  text: string.isRequired,
}
